import React from 'react';
import PropTypes from 'prop-types';
import control from '../../hocs/control/index';

const Select = ({ error, isChanged, isUsed, ...props }) => {
  return <div>
    <select {...props} {...(isChanged && isUsed && error ? {
      className: `is-invalid-input ${props.className}`
    } : { className: `is-valid-input ${props.className}` }) } />
    {isChanged && isUsed && <span className='cls-danger help-block'>{error} </span>}
  </div>;
};

Select.propTypes = {
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  isChanged: PropTypes.bool,
  className: PropTypes.string,
  isUsed: PropTypes.bool
};

export default control(Select);



// WEBPACK FOOTER //
// ./src/components/react-validation/components/select/index.js